import React, { useEffect, useState } from "react"
import { Header, Button, Label } from "semantic-ui-react"
import ca_x_instacart from "./../../images/ca-x-instacart.svg"
import phoneIcon from "../../images/phone-icon.svg"
import caPhoneIcon from "../../images/ca-phone-icon.svg"
import infoOutlined from "../../images/info-outlined-icon.svg"
import supportIcon from "../../images/support-icon.svg"
import calendarIcon from "../../images/calendar-icon.svg"
import helpIcon from "../../images/help-icon.svg"
import { connect } from "react-redux"
import green_check from "./../../images/green-check.png"
import request_timer from "./../../images/request_timer.png"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  faPhoneAlt,
  faCalendar,
  faInfoCircle,
  faEnvelope,
  faClock
} from "@fortawesome/pro-solid-svg-icons"
import instacartDiscountIcon from "../../images/instacart_discount_icon.svg"
import moment from "moment"
import { HOUR, HOURS } from "../../v1/constants/tires"
import { DATE_TIME_FORMAT } from "../../v1/constants/application"
import AddToCalendar from "react-add-to-calendar"
import { withTranslation } from "react-i18next"
import { PricedAtShop } from "./ServiceRequest/PricedAtShop"
import { gaJSON, trackFirebaseAnalytics } from "../../shared_component/utils/googleAnalyticsHelpers"
import { fetchActiveOrders } from "../../v1/actions/user"

const AppointmentConfirmation = ({ order = {}, history, t, fetchActiveOrders, user }) => {
  const order_services = order.order_services || []
  const services = order_services.map(function (service) {
    return (
      <div className="vertical-padding-5">
        <p className="label" style={{ fontWeight: "500" }}>
          {service.name}
        </p>
        <p className="margin-0 sub-text">{service.position}</p>
      </div>
    )
  })

  const [event, setEvent] = useState()
  useEffect(() => {
    buildEvent()
  }, [order])

  useEffect(() => {
    fetchActiveOrders()
  }, [])

  const goToDashboard = () => {
    history.push(`/dashboard`)
    trackFirebaseAnalytics({
      event: gaJSON.EtoB_go_to_dashboard
    })
  }

  const buildEvent = () => {
    const shop = order.shop

    if (shop) {
      const start = moment(order.appointment_datetime)
      const end = start.clone().add(1, HOUR)
      const duration = end.diff(start, HOURS)
      let eventFormed = {
        title: t("bookingDetails:serviceAtText", { shopName: shop.name }),
        startDatetime: start.format(DATE_TIME_FORMAT.YYYYMMDDTHHmmss),
        endDateTime: end.format(DATE_TIME_FORMAT.YYYYMMDDTHHmmss),
        timezone: shop.timezone,
        duration: `${duration}`,
        description: `${shop.name} ${shop.address_line1} ${shop.city}, ${shop.state} ${shop.zip}`,
        location: `${shop.address_line1} ${shop.city}, ${shop.state} ${shop.zip}`
      }
      setEvent(eventFormed)
    }
  }

  let appointmentStatusText = "Appointment details"
  let appointmentStatus = () => {
    return (
      <div className="appt-status">
        <Header as="h4" className="appt-status-text">
          <p className="appt-status-label">{t("appointmentConfirmed")}</p>
        </Header>
        <img src={green_check} />
      </div>
    )
  }
  if (order.status === "walk_in") {
    appointmentStatusText = "Walk-in details"
    appointmentStatus = () => {
      return (
        <div className="appt-status">
          <Header as="h4" className="appt-status-text">
            <p className="appt-status-label">{t("walkinConfirmation")}</p>
          </Header>
          <img src={green_check} />
        </div>
      )
    }
  }
  if (order.status === "initiated" || order.status === "initiated_by_user") {
    appointmentStatusText = "Appointment request details"
    appointmentStatus = () => {
      return (
        <div className="appt-status">
          <Header as="h4" className="appt-status-text">
            <p className="appt-status-label">{t("appointmentRequested")}</p>
          </Header>
          <img src={request_timer} />
        </div>
      )
    }
  }

  let appointmentStatusBanner = () => {
    if (user.country === "ca") {
      return (
        <div className="row-flex-start need-to-reschedule-container">
          <FontAwesomeIcon icon={faInfoCircle} style={{ paddingRight: "5px" }} />
          <div style={{ lineHeight: "18px" }}>
            <b>{t("thisServiceIsNotAConfirmedAppointment")} </b>
            {t("waitTimesMayVary")}
          </div>
        </div>
      )
    }

    if (order.status === "walk_in") {
      return (
        <div className="row-flex-start need-to-reschedule-container">
          <FontAwesomeIcon icon={faInfoCircle} style={{ paddingRight: "5px" }} />
          <div style={{ lineHeight: "18px" }}>
            {t("thisIsNotAConfirmedAppointmentWaitTimesMayVary")}{" "}
            <b>{t("callAheadToCheckTheShopsEstimatedWaitTimes")}</b>
          </div>
        </div>
      )
    }

    return null
  }

  let vehicleName = ""
  if (order.vehicle != null) {
    const vehicle = order.vehicle
    if (vehicle.year != null) {
      vehicleName += order.vehicle.year + " "
    }
    if (vehicle.make != null) {
      vehicleName += order.vehicle.make + " "
    }
    if (vehicle.model != null) {
      vehicleName += order.vehicle.model + " "
    }
  }

  let appointmentTime = " | " + order.appointment_time_pretty
  if (order.status === "walk_in") {
    appointmentTime = ""
  }

  return (
    <div className="appointment-confirmation-container">
      <img className="ca-x-ic-image" src={ca_x_instacart} />
      <div className="spacer-10" />
      {appointmentStatus()}
      <div className="spacer-10" />
      {appointmentStatusBanner()}
      {(order.status === "initiated" || order.status === "initiated_by_user") && (
        <div
          className="row-flex-start need-to-reschedule-container"
          style={{ color: "#B83614", backgroundColor: "#FEF6F4" }}
        >
          <FontAwesomeIcon icon={faClock} style={{ paddingRight: "5px" }} />
          <div style={{ lineHeight: "18px" }}>
            <b>{t("awaitingConfirmation")}</b> {t("youllBeNotifiedByTextOrPhone")}
          </div>
        </div>
      )}
      <hr className="hr-solid" />
      <div className="appt-details">
        <Header as="h4">
          <p className="appt-status-header">{appointmentStatusText}</p>
        </Header>
        {services}
        <div className="vertical-padding-5">
          <p className="label">{t("vehicle")}</p>
          <p className="margin-0 sub-text">{vehicleName}</p>
        </div>
        <div className="vertical-padding-5">
          <p className="label">{order.shop ? order.shop.name : ""}</p>
          <p className="margin-0 sub-text">{order.shop ? order.shop?.address_line1 : ""}</p>
        </div>
        {order.shop?.main_phone_number && (
          <div className="row-flex-start">
            <img src={phoneIcon} style={{ paddingRight: "5px", height: "16px", width: "16px" }} />
            <p className="margin-0 sub-text">{order.shop?.main_phone_number}</p>
          </div>
        )}
        {order.appointment_date_pretty && (
          <div className="row-space-between">
            <div className="row-flex-start" style={{ color: "#B83614", alignItems: "center" }}>
              <img
                src={calendarIcon}
                style={{ paddingRight: "5px", height: "16px", width: "16px" }}
              />
              <div style={{ fontWeight: 500 }}>
                {order.appointment_date_pretty.split(", ")[1]}
                {", "}
                {order.appointment_date_pretty.split(", ")[2]}
                {appointmentTime}
              </div>
            </div>
            {(order.status === "initiated" || order.status === "initiated_by_user") && (
              <AddToCalendar event={event && event} />
            )}
          </div>
        )}
      </div>
      {order.promotions && order.promotions.length > 0 && order.promotions[0].discount > 0 && (
        <div className="discount-banner">
          <div className="discount-banner-text">
            <img className="discount-icon" src={instacartDiscountIcon} />
            <div>
              {t("yourGuaranteed")} <b>{order.promotions[0].discount}%</b>{" "}
              {t("discountPlusAnyEligiblePromoCodesWillBeAppliedBeforeYouPay")}
            </div>
          </div>
        </div>
      )}
      <div className="row-space-between vertical-padding-5 est-total">
        <div>{t("estimatedTotal")}*</div>
        {(user && user.country === "ca") ||
        (order &&
          (order.no_order_service_has_shop_price ||
            order.total === 0 ||
            order.estimated_total === 0)) ? (
          <PricedAtShop />
        ) : (
          <div>${order.total || order.estimated_total}</div>
        )}
      </div>
      {(user && user.country === "ca") || order.no_order_service_has_shop_price ? (
        <div className="est-total-disclaimer">
          * {t("excludesSalesTaxAndConvenienceFeeWhichWillBeAddedToAllOrders")}
        </div>
      ) : (
        <div className="est-total-disclaimer">
          *{" "}
          {t(
            "theFinalCostMayVaryBasedOnPartsAvailabilityYourSpecificVehicleAndAnyAdditionalServicesNeeded"
          )}
        </div>
      )}
      {user &&
        user.country !== "ca" &&
        (order.status === "walk_in" ||
          order.status === "initiated" ||
          order.status === "initiated_by_user") && (
          <div className="row-flex-start need-to-reschedule-container">
            <img src={infoOutlined} className="padding-right-10" />
            <div className="need-to-reschedule-text">
              <b>{t("needToReschedule")}</b>{" "}
              {t("youCanEasilyManageYourAppointmentThroughTheDashboard")}
            </div>
          </div>
        )}
      <Button fluid basic color="black" className="secondary-button" onClick={goToDashboard}>
        <div className="font-weight-700">{t("goToMyDashboard")}</div>
      </Button>
      <hr className="hr-solid" />
      <div className="whats-next">
        <b>{t("whatsNext")}</b>
      </div>
      <div className="whats-next-container">
        <div className="row-flex-start">
          <Label circular color="#FEF6F4" size="small">
            1
          </Label>
          <div>{t("checkinYourVehicleAtTheShop")}</div>
        </div>
        <div className="row-flex-start">
          <Label circular color="#FEF6F4" size="small">
            2
          </Label>
          <div>{t("shopSubmitsTheInvoice")}</div>
        </div>
        <div className="row-flex-start">
          <Label circular color="#FEF6F4" size="small">
            3
          </Label>
          <div>{t("theServiceIsApproved")}</div>
        </div>
        <div className="row-flex-start">
          <Label circular color="#FEF6F4" size="small">
            4
          </Label>
          <div>{t("yourPaymentMethodIsCharged")}</div>
        </div>
      </div>
      <div className="discount-banner">
        <div className="row-flex-start discount-banner-text">
          <img src={infoOutlined} className="padding-right-10" />
          <div>
            {t("paySecurelyThroughTheAppToReceiveYourExclusiveCarAdviseDiscount")}{" "}
            <b>{t("onceTheWorkIsApprovedYourPaymentMethodOnFileWillBeCharged")}</b>
          </div>
        </div>
      </div>
      <hr className="hr-solid" />
      <div className="whats-next">
        <b>{t("questionsOrConcerns")}</b> {t("ourSupportTeamIsHereToHelp")}
      </div>
      <div className="row-flex-start align-center">
        <img src={supportIcon} style={{ paddingRight: "5px", height: "16px", width: "16px" }} />
        <p className="margin-0">support@caradvise.com</p>
      </div>
      <div className="row-flex-start align-center">
        <img src={caPhoneIcon} style={{ paddingRight: "5px", height: "16px", width: "16px" }} />
        <p className="margin-0">(844) 923-8473</p>
      </div>
      {user && user.country === "ca" && (
        <a
          className="row-flex-start align-center"
          href="https://caradvise.com/faq/"
          style={{ textDecoration: "underline" }}
        >
          <img src={helpIcon} style={{ paddingRight: "5px", height: "16px", width: "16px" }} />
          <p className="margin-0">{t("clickHereToGetMoreInformation")}</p>
        </a>
      )}
    </div>
  )
}

function mapStateToProps(state, props) {
  const user = state.user
  let order =
    user.active_orders &&
    user.active_orders.filter((o) => o.id === parseInt(props.match.params.id))[0]
  if (!order)
    order =
      user.closed_orders &&
      user.closed_orders.filter((o) => o.id === parseInt(props.match.params.id))[0]

  return {
    user: state.user,
    order: order
  }
}

export default connect(mapStateToProps, { fetchActiveOrders })(
  withTranslation("serviceRequest")(AppointmentConfirmation)
)
